import { Docente } from './../models/didattica/docente';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NavController, ModalController, NavParams, ToastController, IonInput } from '@ionic/angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';

import { AttivitaReale } from '../models/didattica/attivita-reale';
import { ConfigService } from '../services/config-service/config-service';
import { ChiaveConfig } from '../models/configurazioni/ChiaveConfig';
import { AbstractPage } from '../AbstractPage';
import { TranslateService } from '@ngx-translate/core';
import { UtilityService } from '../services/utility.service';
import { UserService } from '../services/user-service';
import format from 'date-fns/format';
import { Rilevazione } from '../models/rilevazione-presenze/rilevazione';
import { RilevazionePresenzeService } from '../services/rilevazione-presenze-service';
import { Presenza } from '../models/rilevazione-presenze/presenza';
import { DidatticaService } from '../services/didattica-service';
import { DataService } from '../services/data-service';
@Component({
    selector: 'app-avvio-rilevazione',
    templateUrl: './avvio-rilevazione.page.html',
    styleUrls: ['./avvio-rilevazione.page.scss'],
    standalone: false
})
/**
 * Il form che viene mostrato al docente prima dell'avvio di una rilevazione
 * E' usato come modale
 */
export class AvvioRilevazionePage extends AbstractPage implements OnInit {

  @Input() rilevazione: Rilevazione;
  @ViewChild('dateTime') dateTime: IonInput;

  form: FormGroup;
  ar: AttivitaReale;
  doc: Docente;
  presenze: Presenza[];
  presenzeCopiate = [];
  attivita: AttivitaReale[];
  isPresenze = 0;
  showPresenze = false;
  minutiConsentiti = [15, 30, 45];
  dataCorrente = format(new Date(), 'yyyy-MM-dd' + '\'T\'' + 'HH:mm');
  disabled = false;
  oreAccademiche = this.configService.getConfigurazione(ChiaveConfig.VAL_ORE_ACCADEMICHE);
  cdsList = this.configService.getConfigurazione(ChiaveConfig.CDS_LIST_REDUCED_HOURS).split(",");
  enableOldRilCreation = false;

  ngOnInit() {
    console.log('ngOnInit AvvioRilevazionePage ' );
    this.form.controls['moderoglezione'].setValue('p');
    if (this.userService.isPTA() || this.enableOldRilCreation) {
      this.form.controls['istanteCreazione'].setValue(this.dataCorrente);
    }

    this.doc = this.userService.getDocenteCorrente();

    if (this.rilevazione) {
      this.caricaAttivitaRilevazione(this.doc, this.rilevazione.ar.annoAccademico);
      this.rilevazionePresenzeService.getPresenze(this.rilevazione).subscribe(presenze => {
        this.presenze = presenze;
        this.isPresenze = presenze.length;
        console.log('this.presenze ', this.presenze);
      });
      this.form.controls['ore'].setValue(this.rilevazione.durata / 60);
      this.form.controls['istanteCreazione'].setValue(format(new Date(this.rilevazione.istanteCreazione), "yyyy-MM-dd"+"'T'"+"HH:mm"));
      if (this.rilevazione.note) {
        this.form.controls['note'].setValue(this.rilevazione.note);
      }
    }

    if (this.configService.indicaTipoAttivita && this.ar.suddivisioneOre) {
       console.log('this.ar.suddivisioneOre', this.ar.suddivisioneOre);
       this.form.controls['tipoAttivita'].setValue('LEZ');
       this.setTipoAttivitaDesc('LEZ');
    }
  }
  setTipoAttivitaDesc(cod: string) {
       this.form.controls['tipoAttivitaDesc'].setValue(
        this.ar.suddivisioneOre.find(sudd => sudd.cod === cod)?.desc
       );
  }

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    protected router: Router,
    public route: ActivatedRoute,
    private modalCtrl: ModalController,
    private formBuilder: FormBuilder,
    private configService: ConfigService,
    public utilityService: UtilityService,
    public userService: UserService,
    private rilevazionePresenzeService: RilevazionePresenzeService,
    public didatticaService: DidatticaService,
    private toastCtrl: ToastController,
    private translateService: TranslateService,
    private dataService: DataService
      ) {
    super(navCtrl, router);

    if (navParams.get('ar')) {
      this.ar = navParams.get('ar');
      this.enableOldRilCreation = navParams.get('enableOldRilCreation');
    } else {
      this.rilevazione = this.dataService.rilevazione;
    }

    // console.log(`ar in modal: ${JSON.stringify( this.ar) }`);
    const durataDiDefault = this.configService.getConfigurazione(
      ChiaveConfig.DURATA_LEZIONE
    );
    // definizione dei campi del form
    this.form = this.formBuilder.group({
      ore: [
        durataDiDefault,
        Validators.compose([
          // Validators.minLength(1),
          Validators.maxLength(2),
          Validators.pattern('[0-9 ]*'),
          Validators.required
        ])
      ],
      minuti: [
        Validators.compose([
          Validators.maxLength(2),
        ])
      ],
      moderoglezione: [
        Validators.compose([
          Validators.maxLength(2),
        ])
      ],
      istanteCreazione: [
        Validators.required
      ],
      presenti: [

      ],
      tipoAttivita: [
      ],
      tipoAttivitaDesc: [
      ],
      note: [
        '',
        Validators.compose([
          Validators.maxLength(1000),
        ])
      ],
      attivitaReale: [
        Validators.required
      ],
      all: [

      ],
      now: [

      ]
    });
    this.form.valueChanges.subscribe((v) => {
      console.log('v', v);
      if ( v.ore < 0 )  {
        return;
      }
      if ((!v.minuti && ( v.ore === 0 || v.ore === null)) ) {
        this.form.controls['minuti'].setErrors({'incorrect': true});
        this.form.controls['ore'].setErrors({'incorrect': true});
      } else {
        this.form.controls['minuti'].setErrors(null);
        this.form.controls['ore'].setErrors(null);
      }
    });

  }
  selezionaTipoAttivita(event: any) {
    console.log('event', event);
    if (event) {
      this.setTipoAttivitaDesc(event.detail.value);
    }
  }

  radiochanged() {
    console.log('minuti', this.form.controls['minuti'].value);
  }

  aggiungiPresenza(presenza: Presenza) {
    console.log('presenza', this.form.controls['presenti'].value);
    if (this.form.controls['presenti'].value) {
      this.presenzeCopiate.push(presenza);
    } else {
      const index = this.presenzeCopiate.indexOf(presenza);
      this.presenzeCopiate.splice(index, 1);
    }
  }

  showPresenti() {
    if (this.showPresenze) {
      this.showPresenze = false;
    } else {
      this.showPresenze = true;
    }
  }

  caricaAttivitaRilevazione(docente: Docente, anno: string) {
    if (docente) {
      this.didatticaService
        .cercaAttivitaReali(docente, anno)
        .subscribe(attivita => {
          this.attivita = attivita;
          for (const att of attivita) {
          // if (this.rilevazione) {
            if (att.id === this.rilevazione.ar.id) {
              this.form.controls['attivitaReale'].setValue(att);
              return att;
            }
          // }
          }
          if(!this.form.controls['attivitaReale'].value) {
            this.form.controls['attivitaReale'].setValue(attivita[0]);
            return attivita[0];
          }
        });
    } else { return; }
  }

  selectAll() {
    if (this.form.controls['all'].value) {
      this.form.controls['presenti'].setValue(true);
      this.presenzeCopiate = [];
      this.presenze.forEach(presenza => {
        this.presenzeCopiate.push(presenza);
      });
    } else {
      this.form.controls['presenti'].setValue(false);
      this.presenzeCopiate = [];
    }
  }

  adesso() {
    if (this.form.controls['now'].value) {
      this.dataCorrente = format(new Date(), 'yyyy-MM-dd' + '\'T\'' + 'HH:mm');
      this.form.controls['istanteCreazione'].setValue(this.dataCorrente);
      this.disabled = true;
    } else {
      this.disabled = false;
    }
  }

  async presentToast(mess: string) {
    const toast = await this.toastCtrl.create({
      message: mess,
      duration: 3000,
      // showCloseButton: true,
      // closeButtonText: 'X'
    });
    await toast.present();
  }

  async conferma() {
    if(this.form.value.istanteCreazione > this.dataCorrente && this.userService.isPTA()) {
      this.presentToast(this.translateService.instant('avvio-rilevazione.label.error'));
      return;
    }
    
    if(this.oreAccademiche !== 60 && this.ar.cds.length !== 0) {
      if(this.cdsList.includes(this.ar.cds[0].id)) {
        let message = this.translateService.instant('avvio-rilevazione.label.popup.message', { n: +this.form.value.minuti ? ((this.oreAccademiche * this.form.value.ore) + +this.form.value.minuti) : this.oreAccademiche * this.form.value.ore});
        let title = this.translateService.instant('label.warning');
        this.utilityService.presentSimpleAlert(message, title, async () => {
          await this.modalCtrl.dismiss({formValue: this.form.value, presenti: this.presenzeCopiate}, 'cancel');
        });
      }
      else {
        await this.modalCtrl.dismiss({formValue: this.form.value, presenti: this.presenzeCopiate}, 'cancel');
      }
    }
    else {
      await this.modalCtrl.dismiss({formValue: this.form.value, presenti: this.presenzeCopiate}, 'cancel');
    }
  }

  async annulla() {
    await this.modalCtrl.dismiss(null, 'cancel');
  }

  async openDateTimePicker() {
    (await this.dateTime.getInputElement()).showPicker();
  }
}
